<app-dynamic-text-widget
  [config]="config"
  [text]="text"
  [singleLine]="false"
  [containerAlignItems]="'normal'"></app-dynamic-text-widget>
